import { ApiEndpoint } from '@/api/registry';
import { useApiQuery } from '@/api/useApiQuery';
import type { ExecutionWithConfig } from '@/features/decisions/scenarios.api.types';
import { useTenant } from '@/providers/TenantProvider';

// One run including its config snapshot. Fetched on demand rather than with the scenario,
// because the config is the largest thing the service returns and nothing on the runs table
// displays it.
//
// A submitted config is immutable (the service enforces it with a trigger), so this never
// needs revalidating once fetched.
export function useExecutionConfig(scenarioRunId: string, runId: string, enabled: boolean) {
  const { tenantAlias } = useTenant();

  return useApiQuery<ExecutionWithConfig>(
    tenantAlias,
    ApiEndpoint.ScenarioExecutionGet,
    { pathParams: { scenarioRunId, runId } },
    {
      enabled: enabled && Boolean(scenarioRunId) && Boolean(runId),
      retry: false,
      staleTime: Infinity,
    },
  );
}
